module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Git-2-d6d544000f661d5925ff946df431c0e9.svg";